import { readNullableString, readString, type JsonObject } from "./http/jsonDecoding";

/** A person as the permission history and the settings name them (the server's `PersonBody`). */
export interface HistoryPerson {
  readonly userId: string;
  /** `null` when the account no longer exists. */
  readonly displayName: string | null;
}

export function decodePerson(person: JsonObject): HistoryPerson {
  return { userId: readString(person, "user_id"), displayName: readNullableString(person, "display_name") };
}
